// extracted by mini-css-extract-plugin
export default {"dlIconFormatter":"src-js-common-components-formatters-IconFormatter---dlIconFormatter---OJ+yF"};